module.exports = "<svg version=\"1.1\" baseProfile=\"tiny\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 210 210\" xml:space=\"preserve\"><polygon fill=\"#FFFFFF\" points=\"80.6,196.7 149.4,127.9 149.4,127.9 172.3,105 172.3,105 172.3,105 149.4,82.1 149.4,82.1 80.6,13.3 57.7,36.3 126.5,105 57.7,173.7 \"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// /Users/jeroenbraspenning/Documents/02.PROCESS/CultuurEindhoven/cultuurprijs_website_2018/Development/eindhoven-cultuurprijs/~/svg-inline-loader!./assets/img/content/wallpaper_shape-3.svg
// module id = 36
// module chunks = 0